"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatMessageContext } from "../contexts";
import { SourceLinks } from "../source-links";
interface AIChatMessageSourceLinksProps {
  className?: string;
}
export function AIChatMessageSourceLinks(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  if (!message.groundingSources) {
    return null;
  }
  const {
    wikiArticleIds,
    docPaths,
    settingsSources
  } = message.groundingSources;
  if ((!wikiArticleIds || wikiArticleIds.length === 0) && (!docPaths || docPaths.length === 0) && (!settingsSources || settingsSources.length === 0)) {
    return null;
  }
  let t1;
  if ($[0] !== message.groundingSources) {
    t1 = <SourceLinks sources={message.groundingSources} />;
    $[0] = message.groundingSources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}